import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["defaultOpen", "onClick", "onModalClose", "useComponent", "ButtonComponent", "children", "text"];
import { useState, cloneElement } from 'react';
import { Image } from 'foundations-components/transitional/components/Image';
import { Link } from 'foundations-components/transitional/components/Link';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function wrapPropsInElement(element, props) {
  return typeof element === 'function' ? element(props) : /*#__PURE__*/cloneElement(element, props);
}
const OpenModalButton = _ref => {
  let {
      defaultOpen = false,
      onClick,
      onModalClose,
      useComponent = 'button',
      ButtonComponent,
      children,
      text
    } = _ref,
    passthroughProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [showModal, setShowModal] = useState(defaultOpen);
  const onClose = () => {
    onModalClose === null || onModalClose === void 0 || onModalClose();
    setShowModal(false);
  };
  const handleClick = () => {
    setShowModal(true);
    onClick === null || onClick === void 0 || onClick();
  };
  const modal = showModal ? wrapPropsInElement(children, {
    onClose
  }) : null;
  const componentMap = {
    image: Image,
    link: Link,
    button: Button
  };
  const ModalComponent = ButtonComponent || componentMap[useComponent];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ModalComponent, Object.assign({
      onClick: handleClick
    }, passthroughProps, {
      children: text
    })), modal]
  });
};
export default OpenModalButton;